import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"

export enum HeroAssets {
    ASHTRAY = "HeroASHTRAY",
    WOMAN_SMOKING = "HeroWOMAN_SMOKING",
    GROUP_1 = "HeroGROUP_1",
    GROUP_1_B = "HeroGROUP_1_B",
    GROUP_2 = "HeroGROUP_2",
    GROUP_3 = "HeroGROUP_3",
    GROUP_4 = "HeroGROUP_4",

    BACKGROUND = "HeroBACKGROUND",
    BABY = "HeroBABY_1",
    BOY_AND_GIRL = "HeroBOY_AND_GIRL",
    DOG = "HeroDOG",
    GROUP_5 = "HeroGROUP_5",
    KID_SITTING = "HeroKID_SITTING",
    TRASHCAN = "HeroTRASHCAN",
    COUNTDOWN = "HeroCOUNTDOWN",
    CIG = "HeroCIG",
    E_CIG = "HeroE_CIG",
    ROOM_SMOKE = "HeroROOM_SMOKE",
    ROOM_SMOKE_2 = "HeroROOM_SMOKE_2",
    ROOM_SMOKE_3 = "HeroROOM_SMOKE_3",

    ENTER_SCREEN = "HeroENTER_SCREEN",
    PLAY_BUTTON = "HeroPLAY_BUTTON",
    PLAY_AGAIN_BUTTON = "HeroPLAY_AGAIN_BUTTON",
    HIGH_SCORES_BUTTON = "HeroHIGH_SCORES_BUTTON",
    QUIT_BUTTON = "HeroQUIT_BUTTON",
    SCORE_SCREEN = "HeroSCORE_SCREEN",

    INTRO = "HeroINTRO",
    EXIT = "HeroEXIT",
    GAME_1_ALL_CIGS = "HeroGAME_1_ALL_CIGS",
    GAME_1_SOME_CIGS = "HeroGAME_1_SOME_CIGS",
    GAME_1_NO_CIGS = "HeroGAME_1_NO_CIGS",
    GAME_2_ALL_CIGS = "HeroGAME_2_ALL_CIGS",
    GAME_2_SOME_CIGS = "HeroGAME_2_SOME_CIGS",
    GAME_2_NO_CIGS = "HeroGAME_2_NO_CIGS",
    GAME_3_ALL_CIGS = "HeroGAME_3_ALL_CIGS",
    GAME_3_SOME_CIGS = "HeroGAME_3_SOME_CIGS",
    GAME_3_NO_CIGS = "HeroGAME_3_NO_CIGS",
    COUGH_1 = "HeroCOUGH_1",
    CRY_1 = "HeroCRY_1",
    COUGH_3 = "HeroCOUGH_3",
    COUGH_4 = "HeroCOUGH_4",
    COUGH_5 = "HeroCOUGH_5",
    COUGH_6 = "HeroCOUGH_6",
}

export function loadAssets(game: Phaser.Game) {
    game.load.spritesheet(HeroAssets.ASHTRAY, CCUtils.asset("super-hero/cig-ashtray.png"), 81, 136)
    game.load.spritesheet(HeroAssets.WOMAN_SMOKING, CCUtils.asset("super-hero/woman.png"), 129, 296)
    game.load.spritesheet(HeroAssets.GROUP_1, CCUtils.asset("super-hero/group1.png"), 190, 359)
    game.load.spritesheet(HeroAssets.GROUP_1_B, CCUtils.asset("super-hero/group1b.png"), 156, 396)
    game.load.spritesheet(HeroAssets.GROUP_2, CCUtils.asset("super-hero/group2.png"), 287, 345)
    game.load.spritesheet(HeroAssets.GROUP_3, CCUtils.asset("super-hero/group3.png"), 203, 241)
    game.load.spritesheet(HeroAssets.GROUP_4, CCUtils.asset("super-hero/group4.png"), 169, 341)
    game.load.spritesheet(HeroAssets.GROUP_5, CCUtils.asset("super-hero/group5.png"), 240, 414)

    game.load.image(HeroAssets.BACKGROUND, CCUtils.asset("super-hero/room.png"))
    game.load.image(HeroAssets.BABY, CCUtils.asset("super-hero/baby.png"))
    game.load.image(HeroAssets.BOY_AND_GIRL, CCUtils.asset("super-hero/kids.png"))
    game.load.image(HeroAssets.DOG, CCUtils.asset("super-hero/dog.png"))
    game.load.image(HeroAssets.KID_SITTING, CCUtils.asset("super-hero/little-girl.png"))
    game.load.image(HeroAssets.TRASHCAN, CCUtils.asset("super-hero/trashcan-counter.png"))
    game.load.image(HeroAssets.COUNTDOWN, CCUtils.asset("super-hero/countdown-board.png"))
    game.load.image(HeroAssets.CIG, CCUtils.asset("super-hero/cig.png"))
    game.load.image(HeroAssets.E_CIG, CCUtils.asset("super-hero/e-cig.png"))
    game.load.image(HeroAssets.ROOM_SMOKE, CCUtils.asset("super-hero/room-smoke.png"))
    game.load.image(HeroAssets.ROOM_SMOKE_2, CCUtils.asset("super-hero/room-smoke2.png"))
    game.load.image(HeroAssets.ROOM_SMOKE_3, CCUtils.asset("super-hero/room-smoke3.png"))

    // Difficulty selection screen.
    game.load.image(HeroAssets.ENTER_SCREEN, CCUtils.asset("super-hero/enter-screen.png"))
    game.load.image(HeroAssets.PLAY_BUTTON, CCUtils.asset("super-hero/play-button.png"))
    game.load.image(HeroAssets.PLAY_AGAIN_BUTTON, CCUtils.asset("super-hero/btn-play-again.png"))
    game.load.image(HeroAssets.HIGH_SCORES_BUTTON, CCUtils.asset("super-hero/btn-high-scores.png"))
    game.load.image(HeroAssets.QUIT_BUTTON, CCUtils.asset("super-hero/btn-quit.png"))
    game.load.image(HeroAssets.SCORE_SCREEN, CCUtils.asset("pong/images/scores-bg.png"))

    game.load.audio(HeroAssets.INTRO, CCUtils.asset("super-hero/audio/difficulty-intro.mp3"))
    game.load.audio(HeroAssets.EXIT, CCUtils.asset("super-hero/audio/exit.mp3"))
    game.load.audio(HeroAssets.GAME_1_ALL_CIGS, CCUtils.asset("super-hero/audio/g1-all-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_1_SOME_CIGS, CCUtils.asset("super-hero/audio/g1-some-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_1_NO_CIGS, CCUtils.asset("super-hero/audio/g1-no-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_2_ALL_CIGS, CCUtils.asset("super-hero/audio/g2-all-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_2_SOME_CIGS, CCUtils.asset("super-hero/audio/g2-some-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_2_NO_CIGS, CCUtils.asset("super-hero/audio/g2-no-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_3_ALL_CIGS, CCUtils.asset("super-hero/audio/g3-all-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_3_SOME_CIGS, CCUtils.asset("super-hero/audio/g3-some-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.GAME_3_NO_CIGS, CCUtils.asset("super-hero/audio/g3-no-cigs-in-trash.mp3"))
    game.load.audio(HeroAssets.COUGH_1, CCUtils.asset("super-hero/audio/cough1.wav"))
    game.load.audio(HeroAssets.CRY_1, CCUtils.asset("super-hero/audio/cough2.wav"))
    game.load.audio(HeroAssets.COUGH_3, CCUtils.asset("super-hero/audio/cough3.mp3"))
    game.load.audio(HeroAssets.COUGH_4, CCUtils.asset("super-hero/audio/cough4.mp3"))
    game.load.audio(HeroAssets.COUGH_5, CCUtils.asset("super-hero/audio/cough5.wav"))
    game.load.audio(HeroAssets.COUGH_6, CCUtils.asset("super-hero/audio/cough6.mp3"))

}
